<template>
  <div>
    <v-head :title="title"></v-head>
    <!--   <div style="text-align: center; padding: 20px 0; background: #f3f3f3">
    <span style=" display: block;">
      您已绑定手机号码
    </span><br>
    {{userInfo.mobile}}<br> -->
    <!--     <van-button round type="primary" @click="smsShow=true">绑定手机号</van-button>
      <van-popup v-model="smsShow">
          <van-field v-model="params.mobile" class="input-item" left-icon="phone" placeholder="请输入您的手机号码"></van-field>
          <van-field class="input-item" v-model="params.code" center clearable placeholder="请输入短信验证码">
              <van-button slot="button" size="small" type="primary" @click="getCode">
                  <template v-if="!isSpend">发送验证码</template>
                  <template v-else>( {{time}} )</template>
              </van-button><br/>
              <van-button slot="button" size="small" type="primary" @click="bindmobileCheck">保存</van-button>
          </van-field>
      </van-popup>
  </div> -->
    <div class="box">
      <div class="base-item">
        <van-cell class="input-item" title="会员类型" :value="memberName" required is-link
          @click="setSelectModel('memberTypeList2','dueName','memberType')" />
      </div>
      <div class="base-item">
        <van-field class="input-item" label="真实姓名" v-model="params.name" required clearable placeholder="请输入真实姓名" />
      </div>
      <div class="base-item">
        <van-cell class="input-item" title="性别" :value="gender" required is-link
          @click="setSelectModel('GENDER','name','gender')" />
      </div>
      <div class="base-item">
        <van-cell class="input-item" title="生日" :value="birthday" required is-link
          @click="setSelectModel('birthday','birthday','birthday')" />
      </div>
      <div class="base-item">
        <van-field class="input-item" label="毕业院校" v-model="params.school" clearable placeholder="请输入毕业院校" />
      </div>
      <div class="base-item">
        <van-field class="input-item" label="所学专业" v-model="params.major" clearable placeholder="请输入所学专业" />
      </div>
      <div class="base-item">
        <van-cell class="input-item" title="政治面貌" :value="getName('POLITICAL_STATUS','partisan')" required is-link
          @click="setSelectModel('POLITICAL_STATUS','name','partisan')" />
      </div>
      <div class="base-item">
        <van-cell class="input-item" title="工作性质" :value="getName('WORK_NATURE','workNature')" is-link
          @click="setSelectModel('WORK_NATURE','name','workNature')" />
      </div>
      <div class="base-item">
        <van-field class="input-item" label="工作单位" v-model="params.company" required clearable placeholder="请输入工作单位" />
      </div>
      <div class="base-item">
        <van-field class="input-item" label="社会任职" v-model="params.socialTenure" required clearable
          placeholder="请输入社会任职" />
      </div>
      <div class="base-item">
        <van-cell class="input-item" title="职称" :value="getName('zhichengList','title')" required is-link
          @click="setSelectModel('zhichengList','label','title', true)" />
      </div>
      <div class="base-item">
        <van-cell class="input-item" title="学历" :value="getName('EDUCATION','education')" required is-link
          @click="setSelectModel('EDUCATION','name','education')" />
      </div>
      <div class="base-item">
        <van-cell class="input-item" title="学位" :value="getName('DEGREE','degree')" required is-link
          @click="setSelectModel('DEGREE','name','degree')" />
      </div>
      <div class="base-item">
        <van-cell class="input-item" title="证件类别" :value="getName('ID_TYPE','idType')" required is-link
          @click="setSelectModel('ID_TYPE','name','idType')" />
      </div>
      <div class="base-item">
        <van-field class="input-item" label="证件号码" v-model="params.idNumber" required clearable placeholder="请输入证件号码" />
      </div>
      <div class="base-item">
        <van-cell class="input-item" title="民族" :value="getName('NATIONALITY','nationality')" required is-link
          @click="setSelectModel('NATIONALITY','name','nationality')" />
      </div>
      <div class="base-item">
        <van-cell class="input-item" title="籍贯" :value="getJgName()" required is-link @click="setCity('jg','name')" />
      </div>
      <div class="base-item">
        <van-field class="input-item" label="工作专业" v-model="params.workMajor" clearable placeholder="请输入工作专业" />
      </div>
      <div class="base-item">
        <van-field class="input-item" label="业务成绩" type="textarea" v-model="params.jobPerformance" clearable
          placeholder="请输入您的业务成绩" />
      </div>
      <div class="base-item">
        <van-cell class="input-item" title="所在地区" :value="getDqName()" required is-link
          @click="setCity('add','name')" />
      </div>
      <div class="base-item">
        <van-field class="input-item" type="textarea" v-model="params.fullAddress" required clearable
          placeholder="请输入您的详细地址" />
      </div>
      <div class="base-item">
        <van-field class="input-item" label="邮政编码" v-model="params.zipcode" clearable placeholder="请输入邮政编码" />
      </div>
      <div class="base-item">
        <van-field class="input-item" label="电子邮箱" v-model="params.email" required clearable placeholder="请输入电子邮箱" />
      </div>
      <div class="base-item">
        <van-field class="input-item" label="手机号码" v-model="params.mobile" required clearable placeholder="请输入手机号码" />
      </div>
      <div class="base-item">
        <van-field class="input-item" label="座机电话" v-model="params.telephone" clearable placeholder="请输入座机电话" />
      </div>
      <div class="base-item">
        <van-cell class="input-item" title="加入分会或总会" :value="getName('branchsList','recommendUnitId')" is-link required
          @click="setSelectModel('branchsList','name','recommendUnitId')" />
      </div>
      <div class="base-item">
        <van-cell class="input-item" title="关注单位" :value="getName('branchsList','concernUnitId')" is-link
          @click="setSelectModel('branchsList','name','concernUnitId')" />
      </div>
      <div class="base-item">
        <van-field class="input-item" type="textarea" v-model="params.experience" required clearable
          placeholder="请输入您的教育及工作经历" />
      </div>
      <div class="base-item">
        <van-field class="input-item" type="textarea" v-model="params.achievement" clearable
          placeholder="请输入您有何发明、著作学术论文（何时何地出版发表）及科普先进事迹" />
      </div>
      <div class="base-item">
        <van-field class="input-item" type="textarea" v-model="params.awards" clearable placeholder="请输入您受过何种奖励" />
      </div>

      <van-button type="primary" size="large" @click="save()">保存</van-button>
    </div>

    <!-- 选择弹窗 -->
    <van-popup v-model="selectModel" position="bottom" :style="{ 'min-height': '20%' }">
      <template v-if="selectKey === 'birthday'">
        <van-datetime-picker :value="params.birthday" type="date" :min-date="minDate" @cancel="onCancel"
          @confirm="onConfirmTime" />
      </template>
      <template v-else>
        <van-picker show-toolbar ref="picker" :value-key="key" :columns="columns" @change="onChange" @cancel="onCancel"
          @confirm="onConfirm" />
      </template>
    </van-popup>
  </div>
</template>


<script>
  import vHead from "../../components/Subhead.vue";
  import { registerMemberEdit, checkMobile, getRegisterCode, bindMobile, verifyRegisterCode } from "@/api/login";
  import {
    Field, Button, Picker, DatetimePicker, Popup, TreeSelect, Area, Toast, Cell,
    CellGroup,
  } from "vant";
  import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

  export default {
    data() {
      return {
        title: "基本资料",
        smsShow: false,
        show: false,
        // areaList,
        showPickerAddress: false,
        showTitle: false,
        allAddress: [],
        items: [],
        addrItems: [],
        titleId: null,
        cityId: null,
        activeId: null,
        activeIndex: null,
        activeIdAddr: null,
        activeIndexAddr: null,
        birthdayS: null,
        member: {
          name: "诸葛孔明",
          company: "蜀国",
          jobPerformance: "八阵图",
          birthday: "",
          position: "军师",
          title: "军事家",
          province: "蜀地",
          fullAddress: "西川",
          zipcode: "200033",
          mobile: "10086",
          telephone: "10010",
          email: "123@163.com"
        },
        params: {
          memberType: null,
          name: "",
          gender: null,
          birthday: "",
          partisan: "",
          workNature: "",
          title: "",
          education: "",
          degree: "",
          idType: "",
          nationality: "",
          recommendUnitId: "",
          concernUnitId: "",
          nativeProvince: "",
          nativeCity: "",
          province: "",
          city: "",
          titleFileId: null,
          portraitId: null,
          school: "",
          major: "",
          company: "",
          socialTenure: "",
          idNumber: "",
          workMajor: "",
          jobPerformance: "",
          fullAddress: "",
          zipcode: "",
          email: "",
          mobile: "",
          telephone: "",
          experience: "",
          achievement: "",
          awards: ""
        },
        minDate: null,
        time: 60,
        isSpend: false,
        columns: [],
        key: "", //选择弹窗显示对应的参数名
        selectKey: "", //所选择的字段
        titleGroup: "", //职称第一列的数据
        jgName: "",
        addName: "",
        selectModel: false,
        memberTypeList2: [
          { dueName: "普通会员", memberType: 1, memberTypeText: "普通会员" },
          { dueName: "学生会员", memberType: 2, memberTypeText: "学生会员" },
        ],
      }
    },
    components: {
      vHead,
      [Field.name]: Field,
      [Button.name]: Button,
      [DatetimePicker.name]: DatetimePicker,
      [Popup.name]: Popup,
      [Picker.name]: Picker,
      [TreeSelect.name]: TreeSelect,
      [Area.name]: Area,
      [Toast.name]: Toast,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
    },
    computed: {
      ...mapState(["userInfo", "titleList", "addrList", "memberTypeList", "branchsList", "zhichengList", "cityList"]),
      ...mapGetters([
        "GENDER",
        "POLITICAL_STATUS",
        "EDUCATION",
        "DEGREE",
        "WORK_NATURE",
        "ID_TYPE",
        "NATIONALITY"
      ]),
      //会员类型名称
      memberName() {
        let id = this.params.memberType;

        if (!id) {
          return "内容";
        } else {
          let obj = this.memberTypeList.find(item => item.memberType == id);
          return obj.dueName;
        }
      },
      gender() {
        let id = this.params.gender;
        if (!id && id !== 0) {
          return "内容";
        } else {
          let obj = this.GENDER.find(item => item.value == id);
          if (obj) {
            return obj.name;
          } else {
            return "";
          }
        }
      },
      birthday() {
        let time = this.params.birthday;
        let b = new Date(time);
        if (b) {
          return this.$global.format(b, "yyyy-MM-dd");
        }
      },
      sheng() {
        return this.cityList.filter(item => {
          return item.level === 1;
        });
      },
      shi: function () {
        return this.cityList.filter(item => {
          return item.parentId === this.sheng[0].id;
        });
      }
    },
    methods: {
      ...mapMutations(["setMemberInfo"]),
      ...mapActions([
        "getDictionaryList",
        "getMemberTypeList",
        "getBranchsList",
        "getZhiChengList",
        "getCityList"
      ]),
      getName(list, type) {
        let id = this.params[type];
        if (!id) {
          return "内容";
        } else {
          let obj = {
            name: ""
          };

          if (type == "recommendUnitId" || type == "concernUnitId") {
            obj = this[list].find(item => item.code == id);
          } else if (type === "title") {
            if (!this.params[type]) {
              return ""
            }
            this.titleGroup = this.params[type].toString()[0]
            let group = this[list].find(item => item.value == this.titleGroup);
            let obj = group.children.find(item => item.value == id);

            return obj.label;
          } else {
            obj = this[list].find(item => item.value == id);
          }
          return obj.name;
        }
      },
      getJgName() {
        let name = "";
        if (this.params.nativeProvince) {
          let obj = this.sheng.find(item => item.value == this.params.nativeProvince);
          name = obj.name;
        }
        if (this.params.nativeCity) {
          let obj = this.cityList.find(item => item.value == this.params.nativeCity);
          name = name + obj.name;
        }
        return name;
      },
      getDqName() {
        let name = "";
        if (this.params.province) {
          let obj = this.sheng.find(item => item.value == this.params.province);
          name = obj.name;
        }
        if (this.params.city) {
          let obj = this.cityList.find(item => item.value == this.params.city);
          name = name + obj.name;
        }
        return name;
      },
      setCity(name, key) {
        let obj = this.$refs.picker;
        this.selectModel = true;
        this.key = key;
        this.selectKey = name;

        if (obj) {
          this.$refs.picker.setIndexes([0, 0]);
        }

        this.columns = [
          {
            values: this.sheng,
            className: "column1"
          },
          {
            values: this.shi,
            className: "column2"
          }
        ];
      },
      setSelectModel(type, key, selectKey, ismore) {
        let obj = this.$refs.picker;
        this.selectModel = true;
        this.key = key;
        this.selectKey = selectKey;

        if (obj) {
          this.$refs.picker.setIndexes([0, 0]);
        }
        //是否多级
        if (ismore) {
          this.columns = [
            {
              values: this[type],
              className: "column1"
            },
            {
              values: this[type][0].children,
              className: "column2"
            }
          ];
        } else {
          this.columns = this[type];
        }
      },
      onChange(picker, values, index) {
        if (this.selectKey === "title") {
          // 只有当第一列变化的时候才去设置第二列的值
          if (index === 0) {
            picker.setColumnValues(1, values[0].children || []);
          }
        } else if (this.selectKey === "jg" || this.selectKey === "add") {
          let city = this.cityList.filter(item => {
            return item.parentId === values[0].id;
          });
          if (index === 0) {
            picker.setColumnValues(1, city);
          }
        }
      },
      onConfirm(item) {
        this.selectModel = false;
        if (this.selectKey === "memberType") {
          this.params.memberType = item.memberType;
        } else if (
          this.selectKey === "recommendUnitId" ||
          this.selectKey === "concernUnitId"
        ) {
          this.params[this.selectKey] = item.code;
        } else if (this.selectKey === "title") {
          this.titleGroup = item[0].value;
          this.params[this.selectKey] = item[1] ? item[1].value : "";
        } else if (this.selectKey === "jg") {
          this.params.nativeProvince = item[0].value;
          this.params.nativeCity = item[1] ? item[1].value : "";
          this.jgName = item[0].name + item[1].name;
        } else if (this.selectKey === "add") {
          this.params.province = item[0].value;
          this.params.city = item[1] ? item[1].value : "";
          this.addName = item[0].name + item[1] ? item[1].name : "";
        } else {
          this.params[this.selectKey] = item.value;
        }
      },
      onCancel() {
        this.selectModel = false;
      },
      onConfirmDate(time) {
        this.params.birthday = time;
        this.selectModel = false;
      },
      selectTime() {
        this.show = true;
      },
      onConfirmTime(value) {
        var date = value;
        var m = date.getMonth() + 1;
        var d = date.getDate();
        if (m >= 1 && m <= 9) {
          m = "0" + m;
        }
        if (d >= 0 && d <= 9) {
          d = "0" + d;
        }
        var timer = date.getFullYear() + "-" + m + "-" + d
        console.log("timer", timer)
        this.birthdayS = timer;

        // this.userInfo.birthday = timer.substr(0, 10);
        this.params.birthday = timer;
        this.show = false;
        this.selectModel = false;
      },
      onConfirmAddress(value) {

      },
      selectTitle(date) {
        this.titleId = date.text;
        this.userInfo.title = date.id;
        this.showTitle = false;
      },
      selectAddress(date) {
        this.cityId = date.text;
        this.userInfo.city = date.id;
        this.showPickerAddress = false;
      },
      save() {
        let params = this.params;
        // params.birthday = this.birthdayS.substr(0,10);
        if (!params.name) {
          Toast("真实姓名不能为空!");
          return;
        }
        if (!params.birthday) {
          Toast("生日不能为空!");
          return;
        }
        if (!params.company) {
          Toast("工作单位不能为空!");
          return;
        }
        if (!params.idNumber) {
          Toast("证件号码不能为空!");
          return;
        }
        if (!params.email) {
          Toast("电子邮箱不能为空!");
          return;
        }
        if (!params.recommendUnitId) {
          Toast("加入分会或总会不能为空!");
          return;
        }
        params.birthday = params.birthday.substr(0, 10);
        registerMemberEdit(params)
          .then(res => {
            if (res.success) {
              this.setMemberInfo(res.result);
              window.sessionStorage.setItem("userInfo", JSON.stringify(res.result))
              this.$router.push({ name: 'MemberCenter' });
            } else {
              this.$message.error(res.message)
            }
          })
      },
      count() {
        --this.time;
        if (this.time > 0) {
          setTimeout(() => {
            this.count();
          }, 1000);
        } else {
          this.isSpend = false;
        }
      },
      getTitle(data) {
        let r = [];
        for (let i = 0; i < data.length; i++) {
          var a = new Object();
          a.text = data[i].label;
          a.id = data[i].value;
          if (data[i].children != null && data[i].children.length > 0) {
            //if(res.result[i].hasOwnProperty("children")){
            let s = [];
            for (let j = 0; j < data[i].children.length; j++) {
              let b = new Object();
              b.text = data[i].children[j].label;
              b.id = data[i].children[j].value;
              s.push(b);
              a.children = s;
              if (this.userInfo.title == b.id) {
                this.titleId = b.text;
                this.userInfo.title = b.id;
                this.activeId = b.id;
                this.activeIndex = a.id;
              }
            }
          }
          r.push(a);
        }
        this.items = r;
      },
      getAddrData(data) {
        let addr = [];
        for (let i = 0; i < data.length; i++) {
          var a = new Object();
          a.text = data[i].district.name;
          a.id = data[i].district.value;
          let s = [];
          for (let j = 0; j < data[i].children.length; j++) {
            let b = new Object();
            b.text = data[i].children[j].name;
            b.id = data[i].children[j].value;
            s.push(b);
            a.children = s;
            if (this.userInfo.city == b.id) {
              this.cityId = b.text;
              this.userInfo.city = b.id;
              //this.userInfo.city = b.text;
              //this.cityId = b.id;
            }
          }
          addr.push(a);
        }
        this.addrItems = addr;
      }, getCode() {
        let mobile = this.params.mobile;

        if (this.isSpend) {
          return;
        }

        if (!this.$regexp.mobile(mobile)) {
          Toast("请输入正确的手机号");
          return false;
        }

        this.checkMobiles(mobile);
        //生成签名
        let timestamp = new Date().getTime();
        let data = "appSecretKey=captcha_codes&mobile=" + mobile + "&timestamp=" + timestamp;
        let sign = this.$md5(data);
        getRegisterCode({ mobile: mobile, sign: sign, timestamp: timestamp }).then(res => {
          if (res.success) {
            this.isSpend = true;
            this.time = 60;
            this.count();
          }
        });
      },
      bindmobileCheck() {
        if (!this.params.mobile) {
          Toast.fail("请输入手机号码");
          return
        } else if (!this.params.code) {
          Toast.fail("请输入验证码");
          return
        }

        verifyRegisterCode({ code: this.params.code }).then(res => {
          if (res.success) {
            this.bindMobileSubmit();
          } else {
            this.$tips.error("验证码错误");
          }
        });
      },
      checkMobiles(mobile) {
        let params = {
          mobile
        };

        return new Promise(resolve => {
          checkMobile(params).then(res => {
            if (!res.result && res.success) {
              resolve();
            } else {
              Toast.fail("该手机号码已经注册过！");
            }
          }).catch(() => {
            Toast.fail("该手机号码已经注册过！");
          });
        });
      },
      bindMobileSubmit() {
        let params = {
          memberId: this.userInfo.id,
          memberCategory: this.userInfo.memberCategory,
          oldMobile: this.userInfo.mobile,
          newMobile: this.params.mobile
        }

        bindMobile(params)
          .then(() => {
            this.smsShow = false;
            Toast.success('绑定成功')
          }).catch(() => {
            Toast.fail('绑定失败')
          })

      }
    },

    mounted() {
      this.getDictionaryList();
      this.getMemberTypeList();
      this.getBranchsList();
      this.getZhiChengList();
      this.getCityList();
      // this.getTitle(this.titleList);
      // this.getAddrData(this.addrList);
      let user = window.sessionStorage.getItem("userInfo");
      if (user) {
        this.params = JSON.parse(user);
      }
      // if(this.userInfo && this.userInfo.birthday){
      //   console.log("bbbbb",this.userInfo.birthday)
      //     this.userInfo.birthday = this.userInfo.birthday.substr(0, 10);
      // }
      // this.params = this.userInfo;
      this.minDate = new Date("1920-01-01");
    }

  }
</script>

<style lang="less" scoped>
  /deep/.van-nav-bar .van-icon {
    color: #fff;
  }

  .box {
    padding: 0px 10px;
    border-top: #f3f3f3 solid 15px;
  }

  .van-button--large {
    width: 80%;
    display: block;
    height: 45px;
    line-height: 35px;
    margin: 30px auto;
  }

  .van-button--round {
    height: 35px;
    line-height: 35px;
    margin-bottom: 20px;
  }

  /deep/.van-field__label {
    width: 3rem;
    color: #666;
    font-size: 14px;
  }

  /deep/.van-cell--required {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  /deep/.van-cell {
    border-bottom: #ededed solid 1px;
  }

  /deep/.van-cell__title,
  .van-cell__value {
    margin-left: 15px;
  }
</style>